module.exports = __webpack_public_path__ + "img/gobiernoHidalgo.f3deb327.png";